/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_haiku_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the 5-7-5 haiku pattern?`)
};

const es_syl_haiku_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es el patrón de haiku 5-7-5?`)
};

const de_syl_haiku_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist das 5-7-5-Haiku-Muster?`)
};

const nl_syl_haiku_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is het 5-7-5 haikupatroon?`)
};

const fr_syl_haiku_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce que le schéma de haïku 5-7-5 ?`)
};

const it_syl_haiku_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cos'è lo schema haiku 5-7-5?`)
};

const pt_br2_syl_haiku_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é o padrão haiku 5-7-5?`)
};

const pt_syl_haiku_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é o padrão haiku 5-7-5?`)
};

const ja_syl_haiku_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5-7-5の俳句パターンとは何ですか？`)
};

const zh_syl_haiku_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么是5-7-5俳句格式？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_haiku_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_haiku_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_haiku_faq1_q", locale)
	if (locale === "en") return en_syl_haiku_faq1_q(inputs)
	if (locale === "es") return es_syl_haiku_faq1_q(inputs)
	if (locale === "de") return de_syl_haiku_faq1_q(inputs)
	if (locale === "nl") return nl_syl_haiku_faq1_q(inputs)
	if (locale === "fr") return fr_syl_haiku_faq1_q(inputs)
	if (locale === "it") return it_syl_haiku_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_syl_haiku_faq1_q(inputs)
	if (locale === "pt") return pt_syl_haiku_faq1_q(inputs)
	if (locale === "ja") return ja_syl_haiku_faq1_q(inputs)
	return zh_syl_haiku_faq1_q(inputs)
};